module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-icon-table-flower-2e3cee144c51be247b11a53e394b079b.png";